export default __webpack_public_path__ + "static/media/i.b1c50e08.svg";